import CustomForm from '../../lib/FormValidator/Form/CustomForm'
import { RegistroEntrenador } from '../../system/RegistroEntrenador/RegistroEntrenador'
import { RegistroEntrenadorAssertions } from '../../system/RegistroEntrenador/RegistroEntrenadorAssertions'
import { RegistroEntrenadorTitulo } from '../../system/RegistroEntrenadorTitulo/RegistroEntrenadorTitulo'
import { RegistroEntrenadorAntiguedad } from '../../system/RegistroEntrenadorAntiguedad/RegistroEntrenadorAntiguedad'
import { RegistroEntrenadorCurso } from '../../system/RegistroEntrenadorCurso/RegistroEntrenadorCurso'
import { RegistroEntrenadorAntecedente } from '../../system/RegistroEntrenadorAntecedente/RegistroEntrenadorAntecedente'
class RegistroEntrenadorForm extends CustomForm {
    protected constructor(
    re_id: string,
    re_apellido: string,
    re_nombre: string,
    re_documento_numero: string,
    re_dtid: string,
    re_documento_imagen: File | null,
    re_fecha_nacimiento: Date | null,
    re_genero: string,
    re_domicilio: string,
    re_localidad: string,
    re_proid: number,
    re_cod_postal: string,
    re_tel_fijo: string,
    re_tel_movil: string,
    re_email: string,
    re_email_adicional: string,
    re_fed_id: number,
    re_foto: File | null,
    re_estado: string,
    re_otp_token: string,
    re_fecha_registro: Date,
    re_fecha_confirmacion: Date | null,
    re_fecha_activacion: Date | null,
    re_usid_activacion: string,
    tituloEntrenadorList: RegistroEntrenadorTitulo[],
    antiguedadEntrenadorList: RegistroEntrenadorAntiguedad[],
    cursoEntrenadorList: RegistroEntrenadorCurso[],
    antecedenteEntrenadorList: RegistroEntrenadorAntecedente[]
  )
    {const rea = RegistroEntrenadorAssertions.build()
    super("RegistroEntrenador", rea)
    this.addInputAsserted('re_id', re_id)
    this.addInput('re_apellido', re_apellido)
    this.addInput('re_nombre', re_nombre)
    this.addInput('re_documento_numero', re_documento_numero)
    this.addInput('re_dtid', re_dtid)
    this.addInput('re_documento_imagen', re_documento_imagen)
    this.addInput('re_fecha_nacimiento', re_fecha_nacimiento)
    this.addInput('re_genero', re_genero)
    this.addInput('re_domicilio', re_domicilio)
    this.addInput('re_localidad', re_localidad)
    this.addInput('re_proid', re_proid)
    this.addInput('re_cod_postal', re_cod_postal)
    this.addInput('re_tel_fijo', re_tel_fijo)
    this.addInput('re_tel_movil', re_tel_movil)
    this.addInput('re_email', re_email)
    this.addInput('re_email_adicional', re_email_adicional)
    this.addInput('re_fed_id', re_fed_id)
    this.addInput('re_foto', re_foto)
    this.addInput('re_estado', re_estado)
    this.addInput('re_otp_token', re_otp_token)
    this.addInput('re_fecha_registro', re_fecha_registro)
    this.addInput('re_fecha_confirmacion', re_fecha_confirmacion)
    this.addInput('re_fecha_activacion', re_fecha_activacion)
    this.addInput('re_usid_activacion', re_usid_activacion)
    this.addInput('tituloEntrenadorList', tituloEntrenadorList)
    this.addInput('antiguedadEntrenadorList', antiguedadEntrenadorList)
    this.addInput('cursoEntrenadorList', cursoEntrenadorList)
    this.addInput('antecedenteEntrenadorList', antecedenteEntrenadorList)
}

private static build( re_id: string,
re_apellido: string,
re_nombre: string,
re_documento_numero: string,
re_dtid: string,
re_documento_imagen: File | null,
re_fecha_nacimiento: Date | null,
re_genero: string,
re_domicilio: string,
re_localidad: string,
re_proid: number,
re_cod_postal: string,
re_tel_fijo: string,
re_tel_movil: string,
re_email: string,
re_email_adicional: string,
re_fed_id: number,
re_foto: File | null ,
re_estado: string,
re_otp_token: string,
re_fecha_registro: Date,
re_fecha_confirmacion: Date | null,
re_fecha_activacion: Date | null,
re_usid_activacion: string,
tituloEntrenadorList: RegistroEntrenadorTitulo[],
antiguedadEntrenadorList: RegistroEntrenadorAntiguedad[],
cursoEntrenadorList: RegistroEntrenadorCurso[],
antecedenteEntrenadorList: RegistroEntrenadorAntecedente[]
) {
    return new this( re_id,
    re_apellido,
    re_nombre,
    re_documento_numero,
    re_dtid,
    re_documento_imagen,
    re_fecha_nacimiento,
    re_genero,
    re_domicilio,
    re_localidad,
    re_proid,
    re_cod_postal,
    re_tel_fijo,
    re_tel_movil,
    re_email,
    re_email_adicional,
    re_fed_id,
    re_foto ,
    re_estado,
    re_otp_token,
    re_fecha_registro,
    re_fecha_confirmacion,
    re_fecha_activacion,
    re_usid_activacion,
    tituloEntrenadorList,
    antiguedadEntrenadorList,
    cursoEntrenadorList,
    antecedenteEntrenadorList
  )
}

static initialize() {
    return this.build( 'new',
    '',
    '',
    '',
    '01',
    null,
    null,
    'F',
    '',
    '',
    0,
    '',
    '',
    '',
    '',
    '',
    0,
    null ,
    '',
    '',
    new Date(),
    null,
    null,
    '',
    [],
    [],
    [],
    []
  )
}


getIdInput() { return this.getInputByName('re_id') }

getApellidoInput() { return this.getInputByName('re_apellido') }

getNombreInput() { return this.getInputByName('re_nombre') }

getDocumentoNumeroInput() { return this.getInputByName('re_documento_numero') }

getDtidInput() { return this.getInputByName('re_dtid') }

getDocumentoImagenInput() { return this.getInputByName('re_documento_imagen') }

getFechaNacimientoInput() { return this.getInputByName('re_fecha_nacimiento') }

getGeneroInput() { return this.getInputByName('re_genero') }

getDomicilioInput() { return this.getInputByName('re_domicilio') }

getLocalidadInput() { return this.getInputByName('re_localidad') }

getProidInput() { return this.getInputByName('re_proid') }

getCodPostalInput() { return this.getInputByName('re_cod_postal') }

getTelFijoInput() { return this.getInputByName('re_tel_fijo') }

getTelMovilInput() { return this.getInputByName('re_tel_movil') }

getEmailInput() { return this.getInputByName('re_email') }

getEmailAdicionalInput() { return this.getInputByName('re_email_adicional') }

getFedIdInput() { return this.getInputByName('re_fed_id') }

getFotoInput() { return this.getInputByName('re_foto') }

getEstadoInput() { return this.getInputByName('re_estado') }

getOtpTokenInput() { return this.getInputByName('re_otp_token') }

getFechaRegistroInput() { return this.getInputByName('re_fecha_registro') }

getFechaConfirmacionInput() { return this.getInputByName('re_fecha_confirmacion') }

getFechaActivacionInput() { return this.getInputByName('re_fecha_activacion') }

getUsidActivacionInput() { return this.getInputByName('re_usid_activacion') }

getTituloEntrenadorListInput() { return this.getInputByName('tituloEntrenadorList') }

getAntiguedadEntrenadorListInput() { return this.getInputByName('antiguedadEntrenadorList') }

getCursoEntrenadorListInput() { return this.getInputByName('cursoEntrenadorList') }

getAntecedenteEntrenadorListInput() { return this.getInputByName('antecedenteEntrenadorList') }

toRegistroEntrenador(): RegistroEntrenador {
    return RegistroEntrenador.createFrom(
    this.getIdInput().getValue(),
    this.getApellidoInput().getValue(),
    this.getNombreInput().getValue(),
    this.getDocumentoNumeroInput().getValue(),
    this.getDtidInput().getValue(),
    this.getDocumentoImagenInput().getValue(),
    this.getFechaNacimientoInput().getValue(),
    this.getGeneroInput().getValue(),
    this.getDomicilioInput().getValue(),
    this.getLocalidadInput().getValue(),
    this.getProidInput().getValue(),
    this.getCodPostalInput().getValue(),
    this.getTelFijoInput().getValue(),
    this.getTelMovilInput().getValue(),
    this.getEmailInput().getValue(),
    this.getEmailAdicionalInput().getValue(),
    this.getFedIdInput().getValue(),
    this.getFotoInput().getValue() ,
    this.getEstadoInput().getValue(),
    this.getOtpTokenInput().getValue(),
    this.getFechaRegistroInput().getValue(),
    this.getFechaConfirmacionInput().getValue(),
    this.getFechaActivacionInput().getValue(),
    this.getUsidActivacionInput().getValue(),
    this.getTituloEntrenadorListInput().getValue(),
    this.getAntiguedadEntrenadorListInput().getValue(),
    this.getCursoEntrenadorListInput().getValue(),
    this.getAntecedenteEntrenadorListInput().getValue()
  )
}

}

export default RegistroEntrenadorForm
